import type { HelpFile } from '../../types/help'
import { PatternSuggestDialogTestIds } from '../../../testids/PatternSuggestDialogTestIds'

export const patternSuggestDialogHelp: HelpFile = {
  docPage: '/docs/schema/attribute-definitions',
  texts: {
    [PatternSuggestDialogTestIds.patternAddSample]: null,
    [PatternSuggestDialogTestIds.patternColActions]: null,
    [PatternSuggestDialogTestIds.patternColIndex]: null,
    [PatternSuggestDialogTestIds.patternColValue]: null,
    [PatternSuggestDialogTestIds.patternEmptyState]: 'Beispielwerte eingeben, damit das System ein Validierungs-Regex ableiten kann.',
    [PatternSuggestDialogTestIds.patternInferred]: 'Aus den Beispielen abgeleitetes Regex-Muster — vor der Übernahme prüfen.',
    [PatternSuggestDialogTestIds.patternSampleInput]: 'Beispielwert eingeben, der in die Musterableitung einfließt.',
    [PatternSuggestDialogTestIds.patternSamplesBody]: null,
    [PatternSuggestDialogTestIds.patternSuggestAccept]: 'Abgeleitetes Muster in die Attributdefinition übernehmen.',
    [PatternSuggestDialogTestIds.patternSuggestCancel]: null,
    [PatternSuggestDialogTestIds.patternSuggestClear]: 'Alle Beispiele entfernen und abgeleitetes Muster zurücksetzen.',
    [PatternSuggestDialogTestIds.patternSuggestTitle]: 'Validierungs-Regex aus Beispielwerten ableiten.',
  },
}
